import React from 'react';
import { vkItems } from '../Extlist';
import '../css.css';

const VkItemList = () => {
    return (
        <ul className="vk-ext-list">
            {vkItems.map((item, index) => (
                <li key={index} className="ext-item">
                    <a href={item.pagePath} target="_blank" rel="noopener noreferrer" className="ext-content">
                        <img className='icon' src={item.icon} alt={item.label} />
                        <span className='label-text'>{item.label}</span>
                    </a>
                </li>
            ))}
        </ul>
    );
};

const VkLinkPage = () => {
    return (
        <div className='vk-ext-main'>
            <h1 className="page-title">VK 수역별 링크</h1>
            <VkItemList />
        </div>
    );
};

export default VkLinkPage;
